import { render, staticRenderFns } from "./teamMembers.vue?vue&type=template&id=72f4b679&"
import script from "./teamMembers.vue?vue&type=script&lang=js&"
export * from "./teamMembers.vue?vue&type=script&lang=js&"
import style0 from "./teamMembers.vue?vue&type=style&index=0&id=72f4b679&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports